<template>
  <q-dialog :value="showDetailDialog" persistent>
   <div class="dialog-content">
     <div class="dialog-header">
      <span class="dialog-title">{{ $t("result.cancel.refund.progress.title") }}</span>
       <q-icon v-close-popup name="svg:oclose" class="type-close" @click="onClickOkBtn" />
     </div>
     <div class="refund-status-container flex flex-col justify-center items-center">
       <div class="step-item flex items-center justify-center">
         <img src="https://static.bakmigm.co.id/menu-pc/oms/refund-start.svg" />
         <div class="flex flex-col right-text color-active">
           <span class="step-title">{{ $t("result.cancel.refund.orderCancel.title") }}</span>
           <span class="step-date">{{ formatTime(details.cancelledTime?.dbStamp) }}</span>
           <span class="step-desc">{{ $t("result.cancel.refund.orderCancel.desc") }}</span>
         </div>
       </div>
       <div class="step-item light flex items-center justify-center">
         <img src="https://static.bakmigm.co.id/menu-pc/oms/refund-submit.svg" />
         <div class="flex flex-col right-text color-active">
           <span class="step-title">{{ $t("result.cancel.refund.refundSubmit.title") }}</span>
           <span class="step-date">{{ formatTime(orderRefundData.refundHeader.submitDateTime.dbStamp) }}</span>
           <span class="step-desc">{{ $t("result.cancel.refund.refundSubmit.desc") }} {{
               formatTime(orderRefundData.refundHeader.submitDateTime.dbStamp) }}</span>
         </div>
       </div>
       <div
         v-if="orderRefundData.refundHeader.statusId === 'PENDING'"
         class="step-item flex items-center justify-center"
       >
         <img src="https://static.bakmigm.co.id/menu-pc/oms/refund-pending.svg" />
         <div class="flex flex-col right-text color-pending">
           <span class="step-title">{{ $t("result.cancel.refund.refundPending.title") }}</span>
           <span class="step-desc">{{ $t("result.cancel.refund.refundPending.desc") }}</span>
         </div>
       </div>
       <div
         v-if="orderRefundData.refundHeader.statusId === 'FAILED'"
         class="step-item light flex items-center justify-center"
       >
         <img src="https://static.bakmigm.co.id/menu-pc/oms/refund-failure.svg" />
         <div class="flex flex-col right-text color-active">
           <span class="step-title">{{ $t("result.cancel.refund.refundFailure.title") }}</span>
           <span class="step-date">{{ formatTime(refundResult.statusDateTime.dbStamp) }}</span>
           <span class="step-desc">{{ refundResult.failedReason }}</span>
         </div>
       </div>
       <div
         v-if="orderRefundData.refundHeader.statusId === 'SUCCEEDED'"
         class="step-item light flex items-center justify-center"
       >
         <img src="https://static.bakmigm.co.id/menu-pc/oms/refund-success.svg" />
         <div class="flex  flex-col right-text color-active">
           <span class="step-title">{{ $t("result.cancel.refund.refundSuccess.title") }}</span>
           <span class="step-date">{{ formatTime(refundResult.statusDateTime.dbStamp) }}</span>
           <span class="step-desc">{{ $t("result.cancel.refund.refundSuccess.desc") }}</span>
         </div>
       </div>
     </div>
     <MButton
       v-if="orderRefundData.refundHeader.statusId === 'PENDING'"
       class="refresh-btn flex items-center justify-center gap-2 cursor-pointer"
       :loading="isBtnLoading"
       @click="onClickRefreshBtn"
     >
       <q-icon
          name="app:refresh_icon"
          size="16px"
       />
       <span>{{ $t("result.cancel.refund.refreshStatus") }}</span>
     </MButton>
     <button
       v-else
       class="refresh-btn ok-btn flex items-center justify-center cursor-pointer"
       @click="onClickOkBtn"
     >
       <span>{{ $t("result.cancel.refund.progress.ok") }}</span>
     </button>
   </div>
  </q-dialog>
</template>

<script setup>
import { ref, inject, defineProps, defineEmits, computed, watch, onMounted } from 'vue';
import dayjs from 'dayjs';
import MButton from 'src/components/MButton/index.vue';

const emits = defineEmits(['close']);
const props = defineProps({
  showDialog: {
    type: Boolean,
    default: false,
  },
});

const orderData = inject('orderData');
const updateOrderData = inject('updateOrderData');
const details = computed(() => orderData.value?.orderDetail || {});
const showDetailDialog = ref(false);
const isBtnLoading = ref(false);

watch(() => props.showDialog, (val) => {
  showDetailDialog.value = val;
})

const orderRefundData = computed(() => {
  if (Array.isArray(details.value.payments) && details.value.payments.length > 0) {
    return details.value.payments[0].orderRefund;
  }
  return {
    refundActive: false,
    refundHeader: {
      submitDateTime: 0
    }
  }
})

const refundResult = computed(() => {
  const finalResult = orderRefundData.value.refundHistory.find((item) => item.statusId ===
    orderRefundData.value.refundHeader.statusId)
  return finalResult;
})

const isCancelOrder = computed(() => {
  if (Array.isArray(details.value.payments) && details.value.payments.length > 0) {
    return details.value.payments[0].orderRefund?.refundActive === true;
  }
  return false;
});
const formatTime = ($timestamp) => {
  if (!$timestamp) return '';
  return dayjs($timestamp).format('DD MMMM YYYY HH:mm A')
}
const onClickRefreshBtn = () => {
  isBtnLoading.value = true;
  updateOrderData && updateOrderData();
  setTimeout(() => {
    isBtnLoading.value = false;
  }, 1500)
}

const onClickOkBtn = () => {
  showDetailDialog.value = false;
  emits('close');
}


onMounted(() => {})
</script>


<style lang="scss" scoped>
.dialog-content {
  padding: 24px 16px;
  width: 100%;
  border-radius: 16px;
  background: var(--white, #FFF);
  .dialog-header {
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .dialog-title {
      color: #232323;
      font-family: Montserrat;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 22px; /* 122.222% */
      letter-spacing: -0.54px;
    }
  }


  .refund-status-container {
    margin-bottom: 32px;
    img {
      width: 36px;
      height: 36px;
    }
    .step-item {
      margin-bottom: 48px;
      position: relative;
      gap: 8px;
      flex-wrap: nowrap;
      &::before {
        content: "";
        width: 1px;
        height: 32px;
        position: absolute;
        top: -40px;
        left: 18px;
        background-color: #bdbdbd;
        overflow: hidden;
      }
      &.light {
        &::before {
          background-color: #232323;
        };

      }
      &:first-child {
        &::before {
          width: 0;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .color-active {
      color: #232323;
    }
    .color-pending {
      color: #bdbdbd;
    }
    .step-title {
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 22px; /* 157.143% */
      letter-spacing: -0.42px;
      width: 100%;
    }
    .step-date {
      color: #9E9E9E;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 180% */
      letter-spacing: -0.3px;
      width: 100%;
    }
    .step-desc {
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 150% */
      letter-spacing: -0.36px;
      width: 100%;
    }
  }
  .refresh-btn {
    width: 100%;
    height: 40px;
    border: 1px solid #EEE;
    border-radius: 1000px;
    background: var(--White, #FFF);
    color: #232323;
    /* body Gotham */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
    gap: 8px;
    &.ok-btn {
      background: #C63527;
      border: none;
      color: #ffffff;
    }
    :deep(.mbtn-core)  {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
    }
  }

}

</style>
